exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-5ad0e7f0]{width:16px;height:16px;transition:all 1s}.wrapper .arrow[data-v-5ad0e7f0]{width:14px;height:14px;margin-top:1px;margin-right:1px;overflow:hidden;position:relative}@media (max-width:990px){.wrapper .arrow[data-v-5ad0e7f0]{margin-right:0;margin-left:1px}}.wrapper .fill[data-v-5ad0e7f0]{background:#feea01;width:9.99px;height:9.99px;position:absolute;transform:rotate(45deg);right:-2px;transform-origin:50% 100%}@media (max-width:990px){.wrapper .fill[data-v-5ad0e7f0]{transform:rotate(45deg);top:-2px;right:auto;transform-origin:100% 50%}}@media (max-width:768px){.wrapper[data-v-5ad0e7f0]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ad0e7f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CounterMarks/components/DynamicArrow.vue
// module id = 74
// module chunks = 0